<template>
  <div id="andonpanel">
    <div v-if="andon" class="andon-card">
      <img class="andon-icon" src="../../../assets/icons/andon-exclamation.svg" alt="">
    </div>

    <div v-if="!andon" class="andon-card" style="background-color: #74b567; border-color: rgb(37 162 12);">
      <img class="andon-icon" src="../../../assets/icons/andon-correct.svg" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'AndonCard',
  props: ['andon'],
  data () {
    return {
      checkbox_validation: false,
    }
  },
}
</script>
<style>
  #andonpanel {
    cursor: pointer;
  }
  .andon-card {
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #f08080;
    display: flex;
    padding: 0.5rem;
    margin: 1rem auto 1rem;
    width: 100%;
    border-radius: 10px;
    border-bottom: 12px solid #e93232;
    box-shadow: 2px 2px 15px 0 rgb(152 152 152 / 60%);
  }

  .andon-information {
    padding-left: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .close-andon input {
    display: none;
  }

  .close-andon input,
  .close-andon label {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 2rem;
    height: 2rem;
  }

  @media screen and (orientation: portrait) {
    .andon-icon {
      height: 4rem;
    }
  }

  @media screen and (orientation: landscape) {
    .andon-icon {
      height: 2.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/andon/detailed/AndonCard.vue